import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const SERVICE_PRODUCTS_QUERY = gql`
  query serviceProductsQuery($serviceProductList: [String!]) {
    serviceProducts(serviceProductList: $serviceProductList) {
      displayName
      service
    }
  }
`;

export function useServiceProducts({ serviceProductList }) {
  const { data, loading, error } = useQuery(SERVICE_PRODUCTS_QUERY, {
    noThrow: true,
    skip: !serviceProductList?.length,
    variables: {
      serviceProductList
    }
  });

  useError(error);

  const serviceProducts = data?.serviceProducts;

  return {
    serviceProducts,
    loading,
    hasError: Boolean(error),
    error
  };
}
